module.exports = __webpack_public_path__ + "img/4.9e1127f1.png";